import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  ArrowsPointingInIcon,
  CubeIcon,
  CurrencyRupeeIcon,
  ListBulletIcon,
} from "@heroicons/react/24/solid";
import { PaperAirplaneIcon } from "@heroicons/react/24/solid";
import {
  ChartBarIcon,
  DocumentChartBarIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";
import { XMarkIcon, ArrowsPointingOutIcon } from "@heroicons/react/24/solid";
import { toast } from "react-toastify";
import "./../../../App.css";
import Select from "react-select";
import { ChevronDownIcon, Currency, EyeIcon, IndianRupee } from "lucide-react";
import "../../../../src/App.css";
import { Tooltip } from "react-tooltip";
import { Dialog } from "@headlessui/react";
import { AdjustmentsVerticalIcon } from "@heroicons/react/24/outline";
import { use } from "react";



function LeadDashboardPage() {
  let currentLoginIdName = "";
  currentLoginIdName = localStorage.getItem("user_name");

  const currentLoginIdForAdmin = parseInt(localStorage.getItem("role_id"), 10); //current login oda user_id 1 ah irundha ? ella datas um show panrom
  const currentLoginIdForEmployee = JSON.parse(localStorage.getItem("user"))
    ?.employee?.id; // current login oda user la iruka employee oda id namba task la iruka task_member la iruka id oda match aachu apdina and employee oda tasks matum  list out panrom
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const userId = localStorage.getItem("user_id");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [leadDatas, setLeadDatas] = useState([]);
  const [customerDatas, setCustomerDatas] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [activeTabsForLead, setActiveTabsForLeads] = useState("completed");
  const [activeTabsForQuotation, setActiveTabsForQuotation] =
    useState("approved");
  const [activeTabsForTask, setActiveTabsForTask] = useState("completed");
  const [activeTabsForEmployees, setActiveTabsForEmployees] =
    useState("totalEmployees");
  const [fullscreenTable, setFullscreenTable] = useState(null);
  const [allDatasCount, setAllDatasCount] = useState([]);
  const [allLeadDatas, setAllLeadDatas] = useState([]);
  const [allQuotationDatas, setAllQuotationDatas] = useState([]);
  const [quotationAmountByTypeOfWork, setQuotationAmountByTypeOfWork] =
    useState([]);
  const [allTaskDatas, setAllTaskDatas] = useState([]);
  const [allEmployeeDatas, setAllEmployeeDatas] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [statsDetails, setStatsDetails] = useState([]);
  const [dashboardCounts, setDashboardCounts] = useState([]);
  const [leadFilter, setLeadFilter] = useState({
    select_period: "",
    start_date: "",
    end_date: "",
  });
  const tabName = localStorage.getItem("tab_name");

  const [customerFilter, setCustomerFilter] = useState({
    date_filter: "",
    start_date: "",
    end_date: "",
    type_of_work: "",
    date_from: "",
    date_to: "",
    type: "",
  });

  const [leadChartData, setLeadChartData] = useState([]);
  const [customerChartData, setCustomerChartData] = useState([]);
  const [filteredTaskForDashboard, setFilteredTaskForDashboard] = useState([]);
  const [colors, setColors] = useState([]);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const navigate = useNavigate();
  const [resetFilterBtn, setResetFiltersBtn] = useState(false);
  const [futureLeads, setFutureLeads] = useState([]);
  const [salesServiceData, setSalesServiceData] = useState(tabName);
  const [tabNameFilter, setTabNameFilter] = useState(false);
  const [leadStats, setLeadStats] = useState({});

  const [tabs, setTabs] = useState([
    { name: 'sales', href: '#', current: false },
    { name: 'service', href: '#', current: false },
  ]);




  const fetchDashboard = async () => {


    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      // const filteredTasks1 =
      //   currentLoginIdForAdmin === 1
      //     ? [
      //       ...(allTaskDatas?.pending || []),
      //       ...(allTaskDatas?.data?.completed || []),
      //       ...(allTaskDatas?.data?.inprogress || []),
      //       ...(allTaskDatas?.data?.notyetstarted || []),
      //     ]
      //     : [
      //       ...(allTaskDatas?.data?.pending || []).filter((task) =>
      //         task.task_member.some(
      //           (member) =>
      //             parseInt(member.id, 10) ===
      //             parseInt(currentLoginIdForEmployee)
      //         )
      //       ),
      //       ...(allTaskDatas?.data?.completed || []).filter((task) =>
      //         task.task_member.some(
      //           (member) =>
      //             parseInt(member.id, 10) ===
      //             parseInt(currentLoginIdForEmployee)
      //         )
      //       ),
      //       ...(allTaskDatas?.data?.inprogress || []).filter((task) =>
      //         task.task_member.some(
      //           (member) =>
      //             parseInt(member.id, 10) ===
      //             parseInt(currentLoginIdForEmployee)
      //         )
      //       ),
      //       ...(allTaskDatas?.data?.notyetstarted || []).filter((task) =>
      //         task.task_member.some(
      //           (member) =>
      //             parseInt(member.id, 10) ===
      //             parseInt(currentLoginIdForEmployee)
      //         )
      //       ),
      //     ];
      // setFilteredTaskForDashboard(filteredTasks1);

      const responseForDashboard = await axios.get("public/api/dashboard", {
        params: {
          date_filter: customerFilter.date_filter,
          date_from: customerFilter.date_from,
          date_to: customerFilter?.date_to,
          type_of_work: customerFilter?.type_of_work,
          type: tabName,
        },
        headers: { Authorization: `Bearer ${token}` },
      });


      setDashboardCounts(responseForDashboard?.data);

      const typeOfWork = await axios.get("public/api/type-of-works/list", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTypeOfWork(typeOfWork?.data);

      setAllQuotationDatas({
        quotations: responseForDashboard?.data?.quotations || "0",
        quotationWon: responseForDashboard?.data?.quotationWon || "0",
        quotationLost: responseForDashboard?.data?.quotationLost || "0",
        quotationFollowup: responseForDashboard?.data?.quotationFollowup || "0",
        quotationFollowupAmountToday:
          responseForDashboard?.data?.quotationFollowupAmountToday || "0",
        quotationFollowupFutureAmount:
          responseForDashboard?.data?.quotationFollowupFutureAmount || "0",
        quotationFollowupOverdueAmount:
          responseForDashboard?.data?.quotationFollowupOverdueAmount || "0",

        quotationsSentCount:
          responseForDashboard?.data?.quotationsSentCount || "0",
        quotationSendValue:
          responseForDashboard?.data?.quotationSendValue || "0",
        quotationsNotSentCount:
          responseForDashboard?.data?.quotationsNotSentCount || "0",
        quotationNotSendValue:
          responseForDashboard?.data?.quotationNotSendValue || "0",
        quotationSendPendingCount:
          responseForDashboard?.data?.quotationSendPendingCount || "0",
        quotationSendPendingTotal:
          responseForDashboard?.data?.quotationSendPendingTotal || "0",

        quotationTotalValue:
          responseForDashboard?.data?.quotationTotalValue || "0",
        quotationTotalValueFollowup:
          responseForDashboard?.data?.quotationTotalValueFollowup || "0",
        quotationTotalValueLost:
          responseForDashboard?.data?.quotationTotalValueLost || "0",
        quotationTotalValueWon:
          responseForDashboard?.data?.quotationTotalValueWon || "0",
        todayQuotations: responseForDashboard?.data?.todayQuotations || "0",
        futureQuotations: responseForDashboard?.data?.futureQuotations || "0",
        unFollowedQuotations:
          responseForDashboard?.data?.unFollowedQuotations || "0",
      });
      setQuotationAmountByTypeOfWork(
        responseForDashboard?.data?.quotationAmountByTypeOfWork
      );
      setStatsDetails(responseForDashboard?.data);
      setColors(generateColors(responseForDashboard?.data?.typeOfWork));

      const now = new Date();

      // Ensure consistent date parsing by only taking the date portion
      const thisMonthTasks = tasks.filter((item) => {
        try {
          const itemDate = new Date(item?.created_at?.split("T")[0]);
          if (isNaN(itemDate.getTime())) {
            return false;
          }

          return (
            itemDate.getMonth() === now.getMonth() &&
            itemDate.getFullYear() === now.getFullYear()
          );
        } catch (error) {
          if (error?.response?.status === 401) {
            localStorage.removeItem("token");
            navigate("/crm/");
          } else {
            console.error(error);

            console.error("Error parsing date:", item.created_at, error);
            return false;
          }
        }
      });

      setFilteredTasks(thisMonthTasks);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        toast.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();

    setTabs((prev) =>
      prev.map((tab) => ({ ...tab, current: tab.name === tabName }))
    );

  }, []);

  // const colorClasses = [
  //   "border-blue-500 text-blue-500",
  //   "border-green-500 text-green-500",
  //   "border-red-500 text-red-500",
  //   "border-yellow-500 text-yellow-500",
  //   "border-purple-500 text-purple-500",
  //   "border-pink-500 text-pink-500",
  //   "border-indigo-500 text-indigo-500",
  // ];

  const getRandomColorClass = () => {
    return colors[Math.floor(Math.random() * colors.length)];
  };
  const randomColorMap = useMemo(() => {
    const map = {};
    statsDetails?.nonFollowedLeadList?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass();
        }
      });
    });
    return map;
  }, [statsDetails]);

  const todayLeadColorMap = useMemo(() => {
    const map = {};
    statsDetails?.todayLeadList?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass();
        }
      });
    });
    return map;
  }, [statsDetails]);

  const futureLeadColorMap = useMemo(() => {
    const map = {};
    statsDetails?.futureLeadList?.forEach((lead) => {
      lead?.type_of_work?.forEach((work) => {
        if (!map[work.id]) {
          map[work.id] = getRandomColorClass();
        }
      });
    });
    return map;
  }, [statsDetails]);

  const generateColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
      colors.push(color);
    }
    return colors;
  };

  useEffect(() => {
    const formattedData = leadDatas?.map((lead) => ({
      name: lead?.name,
      lead_value: Number(lead?.lead_value),
    }));
    setLeadChartData(formattedData);
  }, [leadDatas]);

  useEffect(() => {
    if (customerDatas && customerDatas.length > 0) {
      // Grouping data by month
      const groupedData = Object.values(
        customerDatas.reduce((acc, item) => {
          const month = new Date(item.created_at)?.toLocaleString("default", {
            month: "short",
            year: "numeric",
          });

          if (!acc[month]) {
            acc[month] = { name: month, Lead: 0, Direct: 0 };
          }

          if (item.status === "Lead") {
            acc[month].Lead += 1;
          } else if (item.status === "Direct") {
            acc[month].Direct += 1;
          }

          return acc;
        }, {})
      );

      setCustomerChartData(groupedData);
    }
  }, [customerDatas]);

  const tryAgain = () => {
    fetchDashboard();
  };

  const Notification = ({ message, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose();
      }, 1000);

      return () => clearTimeout(timer);
    }, [onClose]);

    return (
      <div className="fixed top-24 right-14 w-62 p-4 bg-purple-600 text-white rounded-lg shadow-md">
        <p>{message}</p>
      </div>
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setCustomerFilter({
      ...customerFilter,
      [name]: value,
    });
  };

  const resetFilters = () => {
    setCustomerFilter({
      date_from: "",
      date_to: "",
      date_filter: "",
      type_of_work: "",
    });
    setResetFiltersBtn(true);
    // fetchDashboard();
  };

  useEffect(() => {
    if (resetFilterBtn) {
      fetchDashboard();
      setResetFiltersBtn(false);
    }
  }, [resetFilterBtn]);


  const handleTabClick = (name) => {
    setTabs((prev) =>
      prev.map((tab) => ({ ...tab, current: tab.name === name }))
    );
    localStorage.setItem("tab_name", name);
    setSalesServiceData(name);
    setTabNameFilter(true);
  };

  useEffect(() => {
    if (tabNameFilter) {
      fetchDashboard();
      setTabNameFilter(false);
    }
  }, [tabNameFilter])


  return (
    <div className=" flex-1 rounded-2xl overflow-x-hidden">
      {loading ? (
        <div class="h-screen bg-white">
          <div class="flex justify-center items-center h-full">
            <img
              class="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : error ? (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-300 bg-opacity-50 z-50">
          <div className="shadow-lg p-4 px-12 bg-white rounded-md flex flex-col items-center">
            <XCircleIcon className="h-12 w-12 text-red-600 opacity-75 mb-2" />
            <div className="mb-2 text-center text-gray-800 font-medium">
              {error}
            </div>
            <button
              onClick={tryAgain}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 w-full rounded"
            >
              Retry
            </button>
          </div>
        </div>
      ) : (
        <main className="">
          <div>

            <div className="w-full mt-2 flex justify-center">
              <div className="inline-flex rounded-full bg-gray-100 p-1  border border-gray-200  shadow-sm">
                {tabs.map((tab) => (
                  <button
                    key={tab.name}
                    onClick={() => handleTabClick(tab.name)}
                    className={`px-6 py-2 text-sm font-medium rounded-full transition-all capitalize duration-200 ${tab.current
                      ? "bg-indigo-600 text-white shadow"
                      : "text-gray-600 hover:text-indigo-600 "
                      }`}
                  >
                    {tab.name}
                  </button>
                ))}
              </div>
            </div>

          </div>
          <div className="py-3 grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div className="text-md md:text-md col-span-1 lg:col-span-2 font-semibold text-gray-900 mb-2 flex items-center space-x-4">
                <span>
                  <CubeIcon className="h-6 w-6 text-blue-600" />
                </span>
                <span className="flex space-x-2">
                  <h2 className="uppercase">Dashboard</h2>{" "}
                  <span className="hidden sm:block uppercase">Overview</span>
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
              <div className="text-md md:text-md flex sm:justify-end col-span-1 lg:col-span-2 font-semibold text-gray-900 mb-2 flex items-center space-x-4">
                <h2 className="">
                  Welcome{" "}
                  <span className="text-blue-600 uppercase font-bold">
                    {currentLoginIdName?.replace(/"/g, "")}
                  </span>
                </h2>
              </div>
            </div>
          </div>



          <div className=" flex justify-between  flex-wrap   ">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
              {/* <div className="space-y-3 ">
                <div className="">
                  <label className="block text-sm font-medium text-gray-700">
                    Filter by date
                  </label>
                  <select
                    name="date_filter"
                    value={customerFilter.date_filter}
                    onChange={handleChange}
                    className="border border-gray-300 p-2 rounded w-full mt-2"
                  >
                    <option value="" className="text-gray-300">
                      -- Select --
                    </option>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="this_week">This Week</option>
                    <option value="this_month">This Month</option>
                    <option value="this_year">This Year</option>
                    <option value="custom">Custom Range</option>
                  </select>
                </div>
              </div> */}

              {customerFilter.date_filter === "custom" && (
                <>
                  <div className="space-y-3 ">
                    <div className="">
                      <label className="block text-sm font-medium">
                        Date From
                      </label>
                      <input
                        type="date"
                        name="date_from"
                        value={customerFilter.date_from}
                        onChange={handleChange}
                        className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                      />
                    </div>
                  </div>
                  <div className="space-y-3 ">
                    <div className="w-full">
                      <label className="block text-sm font-medium">
                        Date To
                      </label>
                      <input
                        type="date"
                        name="date_to"
                        value={customerFilter.date_to}
                        onChange={handleChange}
                        className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Type of Work
                </label>
                <Select
                  name="type_of_work"
                  options={typeOfWork?.map((work) => ({
                    value: work.name,
                    label: work.name,
                  }))}
                  value={
                    typeOfWork
                      ?.map((work) => ({ value: work.name, label: work.name }))
                      .find(
                        (option) =>
                          option?.value === customerFilter?.type_of_work
                      ) || null
                  }
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: "type_of_work",
                        value: selectedOption?.value || "",
                      },
                    })
                  }
                  isMulti={false}
                  isClearable={true}
                  placeholder="Select Type of Work"
                  className="react-select-container"
                  classNamePrefix="select"
                />
              </div>
              <div className="  flex gap-2">
                <button
                  onClick={() => fetchDashboard(1)}
                  className="bg-blue-600 mt-6 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
                >
                  Submit
                </button>
                <button
                  onClick={resetFilters}
                  className="bg-gray-200 text-gray-800 mt-6  font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
                >
                  Reset
                </button>
              </div>
            </div>



            <div>
              <button className="block mt-6 w-full sm:w-auto rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                onClick={() => navigate("/crm/lead", {
                  state: {
                    dashboard: true
                  }
                })}
              >
                Add Lead
              </button>
            </div>


          </div>




          {/* <div className="border border-gray-300 p-4 rounded-lg mt-6">
            <h1 className="text-lg font-semibold mb-4">Leads</h1>

            <div className="grid">
              <div className="shadow-sm">
                <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-6 ">
                  {(userId == 1 || userId == 2) && (
                    <>
                      <div className="flex flex-col items-right justify-right p-6 bg-indigo-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onClick={() =>
                          navigate("/crm/lead", {
                            state: {
                              custom_date_filter: customerFilter?.date_filter || "",
                              custom_from_date: customerFilter?.date_from || "",
                              custom_to_date: customerFilter?.date_to || "",
                              totalLeads: true,
                              unFollowedTypeOfWorkFilter:
                                customerFilter?.type_of_work,
                              throughdash: true,
                              ts: Date.now(),
                              salesService: salesServiceData,
                            },
                          })
                        }
                      >
                        <div className="flex items-center gap-4">
                          <div className="p-3 bg-indigo-200 rounded-full">
                            <ChartBarIcon className="h-6 w-6  text-indigo-700" />
                          </div>
                          <div>
                            <div className="text-gray-500 font-medium text-md">
                              Total Leads
                            </div>
                            <div className="text-indigo-900 font-bold text-2xl">
                              {statsDetails?.leads}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="flex flex-col items-right justify-right p-6 bg-yellow-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                    onClick={() =>
                      navigate("/crm/lead", {
                        state: {
                          date_filter: "today",
                          winflag: true,
                          unfollow: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          throughdash: true,
                          salesService: salesServiceData,
                        },
                      })
                    }

                  >
                    <div className="flex items-center gap-4">
                      <div className="p-3 bg-yellow-200 rounded-full">
                        <ChartBarIcon className="h-6 w-6  text-yellow-700" />
                      </div>
                      <div>
                        <div className="text-gray-500 font-medium text-md">
                          Today Leads
                        </div>
                        <div className="text-yellow-900 font-bold text-2xl">
                          {statsDetails?.todayFollowedLeads}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-right justify-right p-6 bg-orange-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                    onClick={() => {
                      const nextDate = new Date();
                      // customerFilter?.date_to || new Date()
                      nextDate.setDate(nextDate.getDate() - 1); // ➕ Add 1 day

                      navigate("/crm/lead", {
                        state: {
                          date_filter: customerFilter?.date_filter || "custom",
                          // from_date: customerFilter?.date_from || "",
                          to_date: nextDate.toISOString().split("T")[0], // ✅ Next day's date
                          winflag: true,
                          unfollowLeads: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          // futureLeads: true
                          throughdash: true,
                          salesService: salesServiceData,

                        },
                      });
                    }}
                  >
                    <div className="flex items-center gap-4">
                      <div className="p-3 bg-orange-200 rounded-full">
                        <ChartBarIcon className="h-6 w-6  text-orange-700" />
                      </div>
                      <div>
                        <div className="text-gray-500 font-medium text-md">
                          UnFollowed Leads
                        </div>
                        <div className="text-orange-900 font-bold text-2xl">
                          {statsDetails?.unFollowedLeads}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-right justify-right p-6 bg-blue-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                    onClick={() =>
                      navigate(`/crm/lead`, {
                        state: {
                          date_filter: customerFilter?.date_filter || "custom",
                          from_date:
                            // customerFilter?.date_from ||
                            new Date(Date.now() + 86400000)
                              .toISOString()
                              .split("T")[0] || "",

                          winflag: true,
                          unfollow: true,
                          futureLeads: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          throughdash: true,
                          salesService: salesServiceData,
                        },
                      })
                    }
                  >
                    <div className="flex items-center gap-4">
                      <div className="p-3 bg-blue-200 rounded-full">
                        <ChartBarIcon className="h-6 w-6  text-blue-700" />
                      </div>
                      <div>
                        <div className="text-gray-500 font-medium text-md">
                          Future Leads
                        </div>
                        <div className="text-blue-900 font-bold text-2xl">
                          {statsDetails?.futureLeads}
                        </div>
                      </div>
                    </div>
                  </div>

                  {(userId == 1 || userId == 2) && (
                    <>
                      <div className="flex flex-col items-right  justify-right p-6 bg-green-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onClick={() =>
                          navigate("/crm/lead", {
                            state: {
                              lead_win_status: "win",
                              winflag: true,
                              from_date: customerFilter?.date_from || "",
                              to_date: customerFilter?.date_to || "",
                              date_filter: customerFilter?.date_filter || "",
                              unFollowedTypeOfWorkFilter:
                                customerFilter?.type_of_work,
                              throughdash: true,
                              salesService: salesServiceData,
                            },
                          })
                        }
                      >
                        <div className="flex items-center gap-4">
                          <div className="p-3 bg-green-200 rounded-full">
                            <ChartBarIcon className="h-6 w-6  text-green-700" />
                          </div>
                          <div>
                            <div className="text-green-500 font-medium text-md">
                              Win Leads
                            </div>
                            <div className="text-green-900 font-bold text-2xl">
                              {statsDetails?.winLeads}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-right justify-right p-6 bg-gray-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer"
                        onClick={() =>
                          navigate("/crm/lead", {
                            state: {
                              lead_loss_status: "loss",
                              winflag: true,
                              from_date: customerFilter?.date_from || "",
                              to_date: customerFilter?.date_to || "",
                              date_filter: customerFilter?.date_filter || "",
                              unFollowedTypeOfWorkFilter:
                                customerFilter?.type_of_work,
                              throughdash: true,
                              salesService: salesServiceData,
                            },
                          })
                        }
                      >
                        <div className="flex items-center gap-4">
                          <div className="p-3 bg-gray-200 rounded-full">
                            <ChartBarIcon className="h-6 w-6  text-gray-700" />
                          </div>
                          <div>
                            <div className="text-gray-500 font-medium text-md">
                              Lost Leads
                            </div>
                            <div className="text-gray-900 font-bold text-2xl">
                              {statsDetails?.lossLeads}
                            </div>
                          </div>
                        </div>
                      </div>

                    </>
                  )}
                </div>
              </div>
            </div>


          </div> */}

          <div className="border border-gray-300 p-1 rounded-lg mt-6">
            <h1 className="text-lg font-semibold mb-4">Leads</h1>

            <div className="mt-4 overflow-x-auto  rounded-lg shadow-sm  p-2">
              <table className="table-auto p-5 w-full ">
                <tbody>
                  {/* TOTAL QUOTATIONS */}
                  {(userId == 1 || userId == 2) && (
                    <>
                      <tr className="bg-gradient-to-r cursor-pointer from-purple-100 to-purple-50 border border-purple-200 rounded-md shadow mb-2"

                        onClick={() =>
                          navigate("/crm/lead", {
                            state: {
                              custom_date_filter: customerFilter?.date_filter || "",
                              custom_from_date: customerFilter?.date_from || "",
                              custom_to_date: customerFilter?.date_to || "",
                              totalLeads: true,
                              unFollowedTypeOfWorkFilter:
                                customerFilter?.type_of_work,
                              throughdash: true,
                              ts: Date.now(),
                              salesService: salesServiceData,
                            },
                          })
                        }
                      >
                        <td className="flex items-center p-3 text-purple-800 font-semibold rounded-l-md">
                          <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-purple-200 text-purple-600 mr-2 rotate-[-90deg]" />
                          Total Lead
                        </td>
                        <td
                          className="text-[20px] font-bold text-purple-700 text-right p-3"
                          id="total-quotations"
                        >
                          {statsDetails?.leads || 0}
                        </td>

                      </tr>

                      <tr className="bg-gradient-to-r cursor-pointer from-green-100 to-green-50 text-green-700 border border-green-200 rounded-md shadow mb-2"

                        onClick={() =>
                          navigate("/crm/lead", {
                            state: {
                              lead_win_status: "win",
                              winflag: true,
                              from_date: customerFilter?.date_from || "",
                              to_date: customerFilter?.date_to || "",
                              date_filter: customerFilter?.date_filter || "",
                              unFollowedTypeOfWorkFilter:
                                customerFilter?.type_of_work,
                              throughdash: true,
                              salesService: salesServiceData,
                            },
                          })
                        }

                      >
                        <td className="flex items-center p-3 col-span-2 font-semibold">
                          <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-green-200 text-green-600 mr-2 rotate-[-90deg]" />
                          Win Leads
                        </td>
                        <td className="text-[20px] font-semibold text-right p-2">
                          {statsDetails?.winLeads || 0}
                        </td>


                      </tr>
                      <tr className="bg-gradient-to-r cursor-pointer from-red-100 to-red-50 text-red-800 border border-red-200 rounded-md shadow mb-2"
                        onClick={() =>
                          navigate("/crm/lead", {
                            state: {
                              lead_loss_status: "loss",
                              winflag: true,
                              from_date: customerFilter?.date_from || "",
                              to_date: customerFilter?.date_to || "",
                              date_filter: customerFilter?.date_filter || "",
                              unFollowedTypeOfWorkFilter:
                                customerFilter?.type_of_work,
                              throughdash: true,
                              salesService: salesServiceData,
                            },
                          })
                        }
                      >
                        <td className="flex items-center p-3 col-span-2 font-semibold">
                          <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-red-200 text-red-600 mr-2 rotate-[-90deg]" />
                          Lost Leads
                        </td>
                        <td className="text-[20px] font-semibold text-right p-2">
                          {statsDetails?.lossLeads}
                        </td>
                      </tr>

                      <tr className="bg-gradient-to-r cursor-pointer from-yellow-100 to-yellow-50 text-yellow-800 border border-yellow-200 rounded-md shadow mb-2"
                      
                      
                        onClick={() => {
                      const nextDate = new Date();
                      // customerFilter?.date_to || new Date()
                      nextDate.setDate(nextDate.getDate() + 1); 

                      navigate("/crm/lead", {
                        state: {
                          date_filter: customerFilter?.date_filter || "custom",
                          // from_date: customerFilter?.date_from || "",
                          to_date: nextDate.toISOString().split("T")[0], // ✅ Next day's date
                          winflag: true,
                          unfollowLeads: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          // futureLeads: true
                          throughdash: true,
                          salesService: salesServiceData,

                        },
                      });
                    }}
                      >
                        <td className="flex items-center p-3 col-span-2 font-semibold">
                          <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-yellow-200 text-yellow-600 mr-2 rotate-[-90deg]" />
                          Followup Leads
                        </td>
                        <td className="text-[20px] font-semibold text-right p-2">
                          {statsDetails?.followupLeads}
                        </td>
                      </tr>
                    </>
                  )}






                  <tr className=" bg-white border-l-4 border-blue-500 rounded-md shadow mb-2 cursor-pointer"
                    onClick={() =>
                      navigate("/crm/lead", {
                        state: {
                          date_filter: "today",
                          winflag: true,
                          unfollow: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          throughdash: true,
                          salesService: salesServiceData,
                        },
                      })
                    }
                  >
                    <td className="flex items-center p-3  font-semibold rounded-l-md">

                      Today Leads
                    </td>
                    <td className="text-[20px] font-semibold text-gray-700 text-right p-3">
                      {statsDetails?.todayFollowedLeads}
                    </td>


                  </tr>
                  <tr className="bg-white border-l-4 border-purple-500 rounded-md shadow mb-2 cursor-pointer"

                    onClick={() =>
                      navigate(`/crm/lead`, {
                        state: {
                          date_filter: customerFilter?.date_filter || "custom",
                          from_date:
                            // customerFilter?.date_from ||
                            new Date(Date.now() + 86400000)
                              .toISOString()
                              .split("T")[0] || "",

                          winflag: true,
                          unfollow: true,
                          futureLeads: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          throughdash: true,
                          salesService: salesServiceData,
                        },
                      })
                    }
                  >
                    <td className="flex items-center p-3 col-span-2 font-semibold">

                      Future Leads
                    </td>
                    <td className="text-[20px] font-semibold text-gray-700 text-right p-3">
                      {statsDetails?.futureLeads}
                    </td>


                  </tr>

                  <tr className="bg-white border-l-4 border-red-500  rounded-md shadow mb-2 cursor-pointer"
                    onClick={() => {
                      const nextDate = new Date();
                      // customerFilter?.date_to || new Date()
                      nextDate.setDate(nextDate.getDate() - 1); // ➕ Add 1 day

                      navigate("/crm/lead", {
                        state: {
                          date_filter: customerFilter?.date_filter || "custom",
                          // from_date: customerFilter?.date_from || "",
                          to_date: nextDate.toISOString().split("T")[0], // ✅ Next day's date
                          winflag: true,
                          unfollowLeads: true,
                          unFollowedTypeOfWorkFilter: customerFilter?.type_of_work,
                          // futureLeads: true
                          throughdash: true,
                          salesService: salesServiceData,

                        },
                      });
                    }}
                  >
                    <td className="flex items-center p-3 text-gray-800 font-semibold rounded-l-md  cursor-pointer "


                    >

                      UnFollow-up Leads
                    </td>
                    <td className="text-[20px] font-semibold text-gray-700 text-right p-3">
                      {statsDetails?.unFollowedLeads}
                    </td>
                    {/* <td className="text-[20px] font-bold text-green-700 text-right p-3 rounded-r-md">
                                          ₹ {allQuotationDatas.quotationSendValue}
                                        </td> */}

                  </tr>
                </tbody>
              </table>
            </div>
          </div>


          <div className="mt-6 overflow-x-auto  rounded-lg shadow-sm border border-gray-300 p-2">
            <h1 className="text-lg bg font-semibold mb-4">Quotations</h1>
            <table className="table-auto p-5 w-full ">
              <tbody>
                {/* TOTAL QUOTATIONS */}
                {(userId == 1 || userId == 2) && (
                  <>
                    <tr
                      className="bg-gradient-to-r cursor-pointer from-purple-100 to-purple-50 border border-purple-200 rounded-md shadow mb-2"
                    // onClick={() =>
                    //   navigate("/crm/quotation", {
                    //     state: {
                    //       typeOfWorkFilter: customerFilter.type_of_work,
                    //       // quotationsDateFilter: customerFilter?.date_from
                    //       quotationsDateFilter: "custom",
                    //       dateFrom: customerFilter.date_from,
                    //       dateTo: customerFilter.date_to,
                    //     },
                    //   })
                    // }
                    >

                      <td
                        className="flex items-center p-3 text-purple-800 font-semibold rounded-l-md"
                        onClick={() => {
                          if (
                            customerFilter?.type_of_work &&
                            !customerFilter?.date_from &&
                            !customerFilter?.date_to
                          ) {
                            // ✅ Case 1: Only Type of Work selected
                            navigate("/crm/quotation", {
                              state: {
                                typeOfWorkFilter: customerFilter.type_of_work,
                                // status: "1. Win",
                              },
                            });
                          } else if (
                            customerFilter?.type_of_work &&
                            customerFilter?.date_from &&
                            customerFilter?.date_to
                          ) {
                            // ✅ Case 2: Type of Work + Date Range selected
                            navigate("/crm/quotation", {
                              state: {
                                // status: "1. Win",
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quotationsDateFilter: "custom",
                                dateFrom: customerFilter.date_from,
                                dateTo: customerFilter.date_to,
                                salesService: salesServiceData,

                                // qDate: "toDate",
                              },
                            });
                          } else {
                            // Optional: If nothing is selected, just navigate normally
                            navigate(
                              "/crm/quotation",

                              {
                                state: { salesService: salesServiceData, },
                              }
                            );
                          }
                        }}
                      >
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-purple-200 text-purple-600 mr-2 rotate-[-90deg]" />
                        Total Quotations
                      </td>
                      <td
                        className="text-[20px] font-bold text-purple-700 text-right p-3"
                        id="total-quotations"
                      >
                        {allQuotationDatas.quotations}
                      </td>
                      <td className="text-center">
                        <button
                          className=" rounded-full  text-white transition-colors"
                          onClick={() => {
                            setIsOpen(true);
                            setSelectedRow("Total Quotation Amount");
                            setValue(allQuotationDatas.quotationTotalValue);
                          }}
                        >
                          <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                        </button>
                      </td>



                      {/* <td className="text-[20px] font-bold text-purple-700 text-right p-3 rounded-r-md">
                      ₹{allQuotationDatas.quotationTotalValue}
                    </td> */}

                    </tr>

                    {/* QUOTATIONS NOT SENT */}
                    <tr
                      className="bg-gradient-to-r cursor-pointer from-red-100 to-red-50 border border-red-200 rounded-md shadow mb-2"
                    // onClick={() =>
                    //   navigate("/crm/quotation", {
                    //     state: {
                    //       quote_sent_status: "No",
                    //       typeOfWorkFilter: customerFilter.type_of_work,
                    //       quotationsDateFilter: "custom",
                    //       dateFrom: customerFilter.date_from,
                    //       dateTo: customerFilter.date_to,
                    //     },
                    //   })
                    // }
                    >
                      <td
                        className="flex items-center p-3 text-red-700 font-semibold rounded-l-md"
                        onClick={() => {
                          if (
                            customerFilter?.type_of_work &&
                            !customerFilter?.date_from &&
                            !customerFilter?.date_to
                          ) {
                            // ✅ Case 1: Only Type of Work selected
                            navigate("/crm/quotation", {
                              state: {
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quote_sent_status: "No",
                                salesService: salesServiceData,
                              },
                            });
                          } else if (
                            customerFilter?.type_of_work &&
                            customerFilter?.date_from &&
                            customerFilter?.date_to
                          ) {
                            // ✅ Case 2: Type of Work + Date Range selected
                            navigate("/crm/quotation", {
                              state: {
                                quote_sent_status: "No",
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quotationsDateFilter: "custom",
                                dateFrom: customerFilter.date_from,
                                dateTo: customerFilter.date_to,
                                // qDate: "toDate",
                                salesService: salesServiceData,
                              },
                            });
                          } else {
                            // Optional: If nothing is selected, just navigate normally
                            navigate("/crm/quotation", {
                              state: { quote_sent_status: "No" },
                            });
                          }
                        }}
                      >
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-red-200 text-red-500 mr-2 rotate-[-90deg]" />
                        Quotations Not Sent
                      </td>
                      <td className="text-[20px] font-bold text-red-600 text-right p-3">
                        {allQuotationDatas.quotationsNotSentCount}
                      </td>
                      {/* <td className="text-[20px] font-bold text-red-700 text-right p-3 rounded-r-md">
                         ₹ {allQuotationDatas.quotationNotSendValue}
                          </td> */}
                      <td className="text-center">
                        <button
                          className="p-2 rounded-full text-white transition-colors"
                          onClick={() => {
                            setIsOpen(true);
                            setSelectedRow("Quotations Not Sent Amount");
                            setValue(allQuotationDatas.quotationNotSendValue);
                          }}
                        >
                          <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                        </button>
                      </td>
                    </tr>

                    {/* QUOTATIONS SENT */}
                    <tr
                      className="bg-gradient-to-r cursor-pointer from-green-50 to-green-100 border border-green-200 rounded-md shadow mb-2"
                    // onClick={() =>
                    //   navigate("/crm/quotation", {
                    //     state: {
                    //       quote_sent_status: "Yes",
                    //       typeOfWorkFilter: customerFilter.type_of_work,
                    //       quotationsDateFilter: "custom",
                    //       dateFrom: customerFilter.date_from,
                    //       dateTo: customerFilter.date_to,
                    //     },
                    //   })
                    // }
                    >
                      <td
                        className="flex items-center p-3 text-green-800 font-semibold rounded-l-md"
                        onClick={() => {
                          if (
                            customerFilter?.type_of_work &&
                            !customerFilter?.date_from &&
                            !customerFilter?.date_to
                          ) {
                            // ✅ Case 1: Only Type of Work selected
                            navigate("/crm/quotation", {
                              state: {
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quote_sent_status: "Yes",
                                salesService: salesServiceData,
                              },
                            });
                          } else if (
                            customerFilter?.type_of_work &&
                            customerFilter?.date_from &&
                            customerFilter?.date_to
                          ) {
                            // ✅ Case 2: Type of Work + Date Range selected
                            navigate("/crm/quotation", {
                              state: {
                                quote_sent_status: "Yes",
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quotationsDateFilter: "custom",
                                dateFrom: customerFilter.date_from,
                                dateTo: customerFilter.date_to,
                                // qDate: "toDate",
                                salesService: salesServiceData,
                              },
                            });
                          } else {
                            // Optional: If nothing is selected, just navigate normally
                            navigate("/crm/quotation", {
                              state: { quote_sent_status: "Yes", salesService: salesServiceData, },
                            });
                          }
                        }}
                      >
                        <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-green-100 text-green-600 mr-2 rotate-[-90deg]" />
                        Quotations Sent
                      </td>
                      <td className="text-[20px] font-bold text-green-700 text-right p-3">
                        {allQuotationDatas.quotationsSentCount}
                      </td>
                      {/* <td className="text-[20px] font-bold text-green-700 text-right p-3 rounded-r-md">
                      ₹ {allQuotationDatas.quotationSendValue}
                    </td> */}
                      <td className="text-center">
                        <button
                          className="p-2 rounded-full text-white transition-colors"
                          onClick={() => {
                            setIsOpen(true);
                            setSelectedRow("Quotation Sent Amount");
                            setValue(allQuotationDatas.quotationSendValue);
                          }}
                        >
                          <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                        </button>
                      </td>
                    </tr>

                    {/* WON */}
                    <tr
                      className="bg-gradient-to-r cursor-pointer from-green-100 to-green-50 text-green-800 border border-green-200 rounded-md shadow mb-2"
                    // onClick={() =>
                    //   navigate("/crm/quotation", {
                    //     state: {
                    //       status: "1. Win",
                    //       typeOfWorkFilter: customerFilter.type_of_work,
                    //       quotationsDateFilter: "custom",
                    //       dateFrom: customerFilter.date_from,
                    //       dateTo: customerFilter.date_to,
                    //     },
                    //   })
                    // }
                    >
                      <td
                        className="flex items-center p-2 col-span-2 font-semibold"
                        onClick={() => {
                          if (
                            customerFilter?.type_of_work &&
                            !customerFilter?.date_from &&
                            !customerFilter?.date_to
                          ) {
                            // ✅ Case 1: Only Type of Work selected
                            navigate("/crm/quotation", {
                              state: {
                                typeOfWorkFilter: customerFilter.type_of_work,
                                status: "1. Win",
                                salesService: salesServiceData,
                              },
                            });
                          } else if (
                            customerFilter?.type_of_work &&
                            customerFilter?.date_from &&
                            customerFilter?.date_to
                          ) {
                            // ✅ Case 2: Type of Work + Date Range selected
                            navigate("/crm/quotation", {
                              state: {
                                status: "1. Win",
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quotationsDateFilter: "custom",
                                dateFrom: customerFilter.date_from,
                                dateTo: customerFilter.date_to,
                                // qDate: "toDate",
                                salesService: salesServiceData,
                              },
                            });
                          } else {
                            // Optional: If nothing is selected, just navigate normally
                            navigate("/crm/quotation", {
                              state: { status: "1. Win" },
                              salesService: salesServiceData,
                            });
                          }
                        }}
                      >
                        <span className="w-2.5 h-2.5 bg-green-500 rounded-full mr-2"></span>
                        Win
                      </td>
                      <td className="text-[20px] font-semibold text-right p-2">
                        {dashboardCounts.quotationWon}
                      </td>
                      {/* <td className="text-[20px] font-semibold text-right p-2">
                      {allQuotationDatas.quotationTotalValueWon}
                    </td> */}
                      <td className="text-center">
                        <button
                          className="p-2 rounded-full text-white transition-colors"
                          onClick={() => {
                            setIsOpen(true);
                            setSelectedRow("Win Amount");
                            setValue(allQuotationDatas.quotationTotalValueWon);
                          }}
                        >
                          <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                        </button>
                      </td>
                    </tr>

                    {/* LOST */}
                    <tr
                      className="bg-gradient-to-r cursor-pointer from-red-100 to-red-50 text-red-700 border border-red-200 rounded-md shadow mb-2"
                    // onClick={() =>
                    //   navigate("/crm/quotation", {
                    //     state: {
                    //       status: "3. Lost",
                    //       typeOfWorkFilter: customerFilter.type_of_work,
                    //       quotationsDateFilter: "custom",
                    //       dateFrom: customerFilter.date_from,
                    //       dateTo: customerFilter.date_to,
                    //     },
                    //   })
                    // }
                    >
                      <td
                        className="flex items-center p-2 col-span-2 font-semibold"
                        onClick={() => {
                          if (
                            customerFilter?.type_of_work &&
                            !customerFilter?.date_from &&
                            !customerFilter?.date_to
                          ) {
                            // ✅ Case 1: Only Type of Work selected
                            navigate("/crm/quotation", {
                              state: {
                                typeOfWorkFilter: customerFilter.type_of_work,
                                status: "3. Lost",
                                salesService: salesServiceData,
                              },
                            });
                          } else if (
                            customerFilter?.type_of_work &&
                            customerFilter?.date_from &&
                            customerFilter?.date_to
                          ) {
                            // ✅ Case 2: Type of Work + Date Range selected
                            navigate("/crm/quotation", {
                              state: {
                                status: "3. Lost",
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quotationsDateFilter: "custom",
                                dateFrom: customerFilter.date_from,
                                dateTo: customerFilter.date_to,
                                // qDate: "toDate",
                                salesService: salesServiceData,
                              },
                            });
                          } else {
                            // Optional: If nothing is selected, just navigate normally
                            navigate("/crm/quotation", {
                              state: { status: "3. Lost", salesService: salesServiceData, },
                            });
                          }
                        }}
                      >
                        <span className="w-2.5 h-2.5 bg-red-500 rounded-full mr-2"></span>
                        Lost
                      </td>
                      <td className="text-[20px] font-semibold text-right p-2">
                        {dashboardCounts.quotationLost}
                      </td>
                      {/* <td className="text-[20px] font-semibold text-right p-2">
                      {allQuotationDatas.quotationTotalValueLost}
                    </td> */}
                      <td className="text-center">
                        <button
                          className="p-2 rounded-full text-white transition-colors"
                          onClick={() => {
                            setIsOpen(true);
                            setSelectedRow("Lost Amount");
                            setValue(allQuotationDatas.quotationTotalValueLost);
                          }}
                        >
                          <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                        </button>
                      </td>
                    </tr>

                    {/* FOLLOW-UP */}
                    <tr
                      className="bg-gradient-to-r cursor-pointer from-yellow-100 to-yellow-50 text-yellow-800 border border-yellow-200 rounded-md shadow mb-2"
                    // onClick={() =>
                    //   navigate("/crm/quotation", {
                    //     state: {
                    //       status: "2. Follow-up",
                    //       typeOfWorkFilter: customerFilter.type_of_work,
                    //       quotationsDateFilter: "custom",
                    //       dateFrom: customerFilter.date_from,
                    //       dateTo: customerFilter.date_to,
                    //     },
                    //   })
                    // }
                    >
                      <td
                        className="flex items-center p-2 col-span-2 font-semibold"
                        onClick={() => {
                          if (
                            customerFilter?.type_of_work &&
                            !customerFilter?.date_from &&
                            !customerFilter?.date_to
                          ) {
                            // ✅ Case 1: Only Type of Work selected
                            navigate("/crm/quotation", {
                              state: {
                                typeOfWorkFilter: customerFilter.type_of_work,
                                status: "2. Follow-up",
                                salesService: salesServiceData,
                              },
                            });
                          } else if (
                            customerFilter?.type_of_work &&
                            customerFilter?.date_from &&
                            customerFilter?.date_to
                          ) {
                            // ✅ Case 2: Type of Work + Date Range selected
                            navigate("/crm/quotation", {
                              state: {
                                status: "2. Follow-up",
                                typeOfWorkFilter: customerFilter.type_of_work,
                                quotationsDateFilter: "custom",
                                dateFrom: customerFilter.date_from,
                                dateTo: customerFilter.date_to,
                                // qDate: "toDate",
                                salesService: salesServiceData,
                              },
                            });
                          } else {
                            // Optional: If nothing is selected, just navigate normally
                            navigate("/crm/quotation", {
                              state: { status: "2. Follow-up", salesService: salesServiceData },
                            });
                          }
                        }}
                      >
                        <span className="w-2.5 h-2.5 bg-yellow-400 rounded-full mr-2"></span>
                        Follow-up
                      </td>
                      <td className="text-[20px] font-semibold text-right p-2">
                        {dashboardCounts.quotationFollowup}
                      </td>
                      <td className="text-center">
                        <button
                          className="p-2 rounded-full text-white transition-colors"
                          onClick={() => {
                            setIsOpen(true);
                            setSelectedRow("Follow-up Amount");
                            setValue(
                              allQuotationDatas.quotationTotalValueFollowup
                            );
                          }}
                        >
                          <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                        </button>
                      </td>
                      {/* <td className="text-[20px] font-semibold text-right p-2">
                      ₹ {allQuotationDatas.quotationTotalValueFollowup}
                    </td> */}
                    </tr>
                  </>
                )}









                {/* FOLLOW-UP DETAILS: TODAY */}
                <tr
                  className="bg-white border-l-4 border-blue-500 rounded-md shadow mb-1"
                // onClick={() =>
                //   navigate("/crm/quotation", {
                //     state: {
                //       status: "2. Follow-up",
                //       quotationsDateFilter: "today",
                //       typeOfWorkFilter: customerFilter.type_of_work,
                //     },
                //   })
                // }
                >
                  <td
                    className="p-2 text-gray-700 font-semibold cursor-pointer"
                    onClick={() => {
                      if (
                        customerFilter?.type_of_work &&
                        !customerFilter?.date_from &&
                        !customerFilter?.date_to
                      ) {
                        // ✅ Case 1: Only Type of Work selected
                        navigate("/crm/quotation", {
                          state: {
                            typeOfWorkFilter: customerFilter.type_of_work,
                            quotationsDateFilter: "today",
                            status: "2. Follow-up",
                            dateFrom: new Date(Date.now())
                              .toISOString()
                              .split("T")[0],
                            salesService: salesServiceData,
                          },
                        });
                      } else if (
                        customerFilter?.type_of_work &&
                        customerFilter?.date_from &&
                        customerFilter?.date_to
                      ) {
                        // ✅ Case 2: Type of Work + Date Range selected
                        navigate("/crm/quotation", {
                          state: {
                            // status: "2. Follow-up",
                            // typeOfWorkFilter: customerFilter.type_of_work,
                            // quotationsDateFilter: "custom",
                            // dateFrom: customerFilter.date_from,
                            // dateTo: customerFilter.date_to,
                            status: "2. Follow-up",
                            quotationsDateFilter: "today",
                            // qDate: "toDate",
                            salesService: salesServiceData,
                          },
                        });
                      } else {
                        // Optional: If nothing is selected, just navigate normally
                        navigate("/crm/quotation", {
                          state: {
                            status: "2. Follow-up",
                            quotationsDateFilter: "today",
                            salesService: salesServiceData,


                          },
                        });
                      }
                    }}
                  >
                    Today's Count
                  </td>
                  <td className="text-blue-600 text-[20px] font-semibold text-right p-2">
                    {dashboardCounts.quotationFollowupToday}
                  </td>
                  {/* <td className="text-blue-600 text-[20px] font-semibold text-right p-2">
                      {dashboardCounts.quotationFollowupAmountToday}
                    </td> */}
                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Today's Amount");
                        setValue(
                          dashboardCounts.quotationFollowupAmountToday
                        );
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* FOLLOW-UP DETAILS: FUTURE */}
                <tr
                  className="bg-white border-l-4 border-purple-500 rounded-md shadow mb-1"
                // onClick={() =>
                //   navigate("/crm/quotation", {
                //     state: {
                //       status: "2. Follow-up",
                //       quotationsDateFilter: "custom",
                //       typeOfWorkFilter: customerFilter.type_of_work,
                //     },
                //   })
                // }
                >
                  <td
                    className="p-2 text-gray-700 font-semibold cursor-pointer"
                    onClick={() => {
                      if (
                        customerFilter?.type_of_work &&
                        !customerFilter?.date_from &&
                        !customerFilter?.date_to
                      ) {
                        // ✅ Case 1: Only Type of Work selected
                        navigate("/crm/quotation", {
                          state: {
                            typeOfWorkFilter: customerFilter.type_of_work,
                            quotationsDateFilter: "custom",
                            status: "2. Follow-up",
                            dateFrom: new Date(
                              Date.now() + 24 * 60 * 60 * 1000
                            )
                              .toISOString()
                              .split("T")[0], // ✅ Tomorrow’s date
                            dateTo: "",
                            salesService: salesServiceData,
                          },
                        });
                      } else if (
                        customerFilter?.type_of_work &&
                        customerFilter?.date_from &&
                        customerFilter?.date_to
                      ) {
                        // ✅ Case 2: Type of Work + Date Range selected
                        navigate("/crm/quotation", {
                          state: {
                            status: "2. Follow-up",
                            typeOfWorkFilter: customerFilter.type_of_work,
                            quotationsDateFilter: "custom",
                            dateFrom: new Date(
                              Date.now() + 24 * 60 * 60 * 1000
                            )
                              .toISOString()
                              .split("T")[0], // ✅ Tomorrow’s date
                            dateTo: "",
                            salesService: salesServiceData,
                            // dateTo: customerFilter.date_to,
                            // qDate: "toDate",
                          },
                        });
                      } else {
                        // Optional: If nothing is selected, just navigate normally
                        navigate("/crm/quotation", {
                          state: {
                            status: "2. Follow-up",
                            quotationsDateFilter: "custom",
                            dateFrom: new Date(
                              Date.now() + 24 * 60 * 60 * 1000
                            )
                              .toISOString()
                              .split("T")[0], // ✅ Tomorrow’s date
                            salesService: salesServiceData,
                          },
                        });
                      }
                    }}
                  >
                    Future Count
                  </td>
                  <td className="text-purple-600 text-[20px] font-semibold text-right p-2">
                    {dashboardCounts.quotationFollowupFuture}
                  </td>
                  {/* <td className="text-purple-600 text-[20px] font-semibold text-right p-2">
                      {dashboardCounts.quotationFollowupFutureAmount}
                    </td> */}
                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Future Amount");
                        setValue(
                          dashboardCounts.quotationFollowupFutureAmount
                        );
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* FOLLOW-UP DETAILS: UNFOLLOWED */}
                <tr
                  className="bg-white border-l-4 border-gray-400 rounded-md shadow mb-1"
                // onClick={() =>
                //   navigate("/crm/quotation", {
                //     state: {
                //       status: "2. Follow-up",
                //       quotationsDateFilter: "custom",
                //       qDate: "toDate",
                //       typeOfWorkFilter: customerFilter.type_of_work,
                //     },
                //   })
                // }
                >
                  <td
                    className="p-2  text-gray-700 font-semibold cursor-pointer"
                    onClick={() => {
                      if (
                        customerFilter?.type_of_work &&
                        !customerFilter?.date_from &&
                        !customerFilter?.date_to
                      ) {
                        // ✅ Case 1: Only Type of Work selected
                        navigate("/crm/quotation", {
                          state: {
                            typeOfWorkFilter: customerFilter.type_of_work,
                            quotationsDateFilter: "custom",
                            status: "2. Follow-up",
                            dateTo: new Date(Date.now() - 24 * 60 * 60 * 1000)
                              .toISOString()
                              .split("T")[0], // ✅ Yesterday’s date
                            dateFrom: "",
                          },
                        });
                      } else if (
                        customerFilter?.type_of_work &&
                        customerFilter?.date_from &&
                        customerFilter?.date_to
                      ) {
                        // ✅ Case 2: Type of Work + Date Range selected
                        navigate("/crm/quotation", {
                          state: {
                            status: "2. Follow-up",
                            typeOfWorkFilter: customerFilter.type_of_work,
                            quotationsDateFilter: "custom",
                            // dateFrom: customerFilter.date_from,
                            // dateTo: customerFilter.date_to,
                            dateTo: new Date(Date.now() - 24 * 60 * 60 * 1000)
                              .toISOString()
                              .split("T")[0], // ✅ Yesterday’s date
                            dateFrom: "",
                            // qDate: "toDate",
                          },
                        });
                      } else {
                        // Optional: If nothing is selected, just navigate normally
                        navigate("/crm/quotation", {
                          state: {
                            status: "2. Follow-up",
                            quotationsDateFilter: "custom",
                            dateTo: new Date(Date.now() - 24 * 60 * 60 * 1000)
                              .toISOString()
                              .split("T")[0],
                            salesService: salesServiceData,
                          },
                        });
                      }
                    }}
                  >
                    Unfollow-up Count
                  </td>
                  <td className="text-gray-700 text-[20px] font-semibold text-right p-2">
                    {dashboardCounts.quotationFollowupOverdue}
                  </td>
                  {/* <td className="text-gray-700 text-[20px] font-semibold text-right p-2">
                      {dashboardCounts.quotationFollowupOverdueAmount}
                    </td> */}
                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Unfollow-Up Amount");
                        setValue(
                          dashboardCounts.quotationFollowupOverdueAmount
                        );
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


          {/* {(userId == 1 || userId == 2) && (
            <>
              <div
                className={`p-4 rounded-2xl shadow-md  mt-10 overflow-x-auto border bg-white transition-all 
               ${isFullScreen
                    ? "fixed top-0     inset-0 z-50 w-full h-full overflow-auto"
                    : ""
                  }`}
              >
                <div className="flex justify-between items-center   ">
                  <h2 className="text-md sm:text-2xl bg- font-bold mb-4">
                    Quotation Status by Type of Work
                  </h2>
                  <>
                    {isFullScreen ? (
                      <ArrowsPointingInIcon
                        className="h-7 w-7 sm:h-6 sm:w-6 mb-4 text-gray-800 cursor-pointer z-50"
                        onClick={() => setIsFullScreen(false)}
                      />
                    ) : (
                      <ArrowsPointingOutIcon
                        className="h-7 w-7 sm:h-6 sm:w-6 mb-4 text-gray-800 cursor-pointer"
                        onClick={() => setIsFullScreen(true)}
                      />
                    )}
                  </>
                </div>

                <table className="min-w-full text-sm text-left border-separate border-spacing-0 rounded-lg overflow-hidden">
                  <thead>
                    <tr className="bg-gradient-to-r from-blue-50 to-blue-100 text-gray-700">
                      <th className="p-3 border-b font-semibold">
                        Type of Work
                      </th>
                      <th className="p-3 border-b font-semibold">Count</th>
                      <th className="p-3 border-b font-semibold">Amount</th>
                      <th className="p-3 border-b font-semibold">Win</th>
                      <th className="p-3 border-b font-semibold">Win Amount</th>
                      <th className="p-3 border-b font-semibold">Loss</th>
                      <th className="p-3 border-b font-semibold">
                        Loss Amount
                      </th>
                      <th className="p-3 border-b font-semibold">Follow-up</th>
                      <th className="p-3 border-b font-semibold">
                        Follow-up Amount
                      </th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    {quotationAmountByTypeOfWork?.length > 0 ? (
                      quotationAmountByTypeOfWork?.map((item, idx) => (
                        <tr
                          key={idx}
                          className={`transition-colors ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                            } hover:bg-blue-50`}
                        >
                          <td
                            className="p-3 border-b cursor-pointer hover:text-blue-600"
                            onClick={() =>
                              navigate("/crm/quotation", {
                                state: {
                                  // typeOfWorkName: item.type_of_work,
                                  typeOfWorkFilter: item.type_of_work,
                                },
                              })
                            }
                          >
                            {item.type_of_work}
                          </td>
                          <td className="p-3 border-b">{item.count}</td>
                          <td className="p-3 border-b font-semibold text-blue-600">
                            ₹{item.amount?.toLocaleString("en-IN")}
                          </td>
                          <td className="p-3 border-b text-green-600 font-medium">
                            {item.win}
                          </td>
                          <td className="p-3 border-b text-green-600 font-medium">
                            {item.win_amount?.toLocaleString("en-IN")}
                          </td>
                          <td className="p-3 border-b text-red-600 font-medium">
                            {item.loss}
                          </td>
                          <td className="p-3 border-b text-red-600 font-medium">
                            {item.loss_amount?.toLocaleString("en-IN")}
                          </td>
                          <td className="p-3 border-b text-yellow-600 font-medium">
                            {item.followup}
                          </td>
                          <td className="p-3 border-b text-gray-600 font-medium">
                            {item.followup_amount?.toLocaleString("en-IN")}
                          </td>
                          
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="p-3 border-b text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )} */}
        </main>
      )}

      {showNotification && (
        <Notification
          message={notificationMessage}
          onClose={() => setShowNotification(false)}
        />
      )}

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="fixed z-50 inset-0 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen px-4">
          <Dialog.Overlay className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300" />
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full z-50 transition-all">
            <Dialog.Title className="text-lg text-purple-800   sm:text-2xl flex items-center gap-2 font-semibold mb-6 border border-gray-300   rounded-t-2xl px-6 py-2">
              <DocumentChartBarIcon className="h-8 w-8 sm:h-10 sm:w-10 text-purple-800 cursor-pointer " />
              {selectedRow}
            </Dialog.Title>
            <div className="space-y-4 px-6">
              <p className="text-base flex items-center gap-2 sm:text-lg text-slate-700 dark:text-slate-300">
                <span className="font-medium text-md sm:text-lg text-green-700">
                  Value:
                </span>
                <span className="text-green-700 text-md sm:text-lg font-bold">
                  ₹{value}
                </span>
              </p>
            </div>
            <div className="mt-2 text-right p-4">
              <button
                className="px-3 py-1 bg-blue-600 text-white rounded shadow hover:bg-blue-700 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default LeadDashboardPage;
